/**
 * Removes hashtag if that character is in position 0,
 * if not, let's throughwithout any modifications.
 */
export default function removeHashtag(string: string | undefined) {
  if (!string) return string;

  if (string.startsWith("#")) string = string.substring(1);

  return string;
}
